<template>
  <v-snackbar
    :value="visible"
    :timeout="timeout"
    class="snackbar"
    app
  >
    <v-row justify="center" class="px-8">
      {{ text }}
    </v-row>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="orange"
        text
        v-bind="attrs"
        @click="$emit('close')"
      >
        <span> Close </span>
      </v-btn>
    </template>
    </v-snackbar>
</template>

<script>
export default {
  name: 'BaseSnackbar',

  props: {
    text: String,
    visible: Boolean,
    timeout: {
      type: Number,
      default: -1
    }
  }
}
</script>

<style lang="sass">
  .snackbar
    font-size: 20em
</style>
